import Button, { buttonClassNames } from '@components/primitives/Button'
import Modal from '@components/primitives/Modal/index.client'
import { classMerge } from '@components/utilities/classMerge'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'

export const PatientCallToSiteSkipModal = ({
  isOpen,
  onSkip,
  setIsOpen,
  whyApplyStory,
}: {
  isOpen: boolean
  onSkip: () => void
  setIsOpen: (open: boolean) => void
  whyApplyStory: string
}) => {
  return (
    <Modal
      bodyClassName='pb-4 h-full'
      className='my-0 h-full max-h-full rounded-none sm:my-[8%] sm:mt-[30%] sm:h-auto sm:max-h-[90vh] sm:rounded-2xl lg:mt-[10%] lg:max-w-3xl'
      onClose={() => {
        trackEvent(TrackingEvents.PATIENT_CALL_TO_SITE_SKIP_MODAL_EXITED)
        setIsOpen(false)
      }}
      sectionClassName='h-full'
      size='Large'
      visible={isOpen}
    >
      <div className='relative mt-1 flex h-full flex-col gap-6 rounded-lg p-4 sm:static'>
        <div className='flex flex-col items-start gap-4'>
          <h3 className='text-2xl font-extrabold leading-[133%] text-black'>
            Are you sure you don’t want to connect with the trial?
          </h3>
          <p className='text-base font-medium leading-[150%] text-neutral600'>
            Spots are limited — 40 patients have already booked their screening
            visits for this trial! Don’t miss your chance to join.
          </p>
        </div>
        <div className='flex w-full flex-col items-start gap-2'>
          <p className='text-sm font-medium leading-[120%] tracking-[1.12px]'>
            WHY OTHER PATIENTS APPLIED
          </p>
          <div className='flex w-full rounded-lg bg-primary50 p-6'>
            <p className='text-base font-bold leading-[150%] text-neutral900'>
              {whyApplyStory}
            </p>
          </div>
        </div>
        <div className='absolute inset-x-0 bottom-4 flex w-full flex-col gap-4 sm:static'>
          <Button
            className={classMerge(
              buttonClassNames.primary.purple,
              'w-full rounded-full text-lg font-bold leading-[150%]',
            )}
            onClick={() => {
              trackEvent(
                TrackingEvents.PATIENT_CALL_TO_SITE_SKIP_MODAL_CONTINUED,
              )
              setIsOpen(false)
            }}
          >
            Continue
          </Button>
          <Button
            className={classMerge(
              buttonClassNames.outline.white,
              'w-full rounded-full text-lg font-bold leading-[150%]',
            )}
            onClick={onSkip}
          >
            Skip
          </Button>
        </div>
      </div>
    </Modal>
  )
}
